import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// In-memory token fallback (survives storage partitioning in preview iframes).
let memToken = null;
export const setToken = (t) => {
  memToken = t || null;
  try { t ? localStorage.setItem("session_token", t) : localStorage.removeItem("session_token"); } catch (e) {}
};
export const getToken = () => {
  if (memToken) return memToken;
  try { return localStorage.getItem("session_token"); } catch (e) { return null; }
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Bearer fallback: preview runs in an overlay/iframe where third-party cookies
// and localStorage may be blocked, so we also send the token via header.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
